import { genId } from '@/utils/id'
import { seedMoments } from '@/mock/seed'
import { filterVisible } from '@/utils/visibility'

export default {
  namespaced: true,
  state: {
    list: seedMoments
  },
  getters: {
    byTrip: state => tripId => state.list.filter(m => m.tripId === tripId),
    visibleByTrip: (state, getters) => (tripId, viewerId) => filterVisible(getters.byTrip(tripId), viewerId),
    byPoint: state => pointId => state.list.filter(m => m.pointId === pointId),
    firstCapturedAt: (state, getters) => tripId => {
      const list = getters.byTrip(tripId).map(m => m.capturedAt).filter(Boolean).sort()
      return list[0] || null
    },
    lastCapturedAt: (state, getters) => tripId => {
      const list = getters.byTrip(tripId).map(m => m.capturedAt).filter(Boolean).sort()
      return list[list.length - 1] || null
    }
  },
  mutations: {
    ADD_MOMENT (state, moment) {
      state.list.unshift(moment)
    },
    UPDATE_MOMENT (state, { id, patch }) {
      const m = state.list.find(x => x.id === id)
      if (m) Object.assign(m, patch)
    },
    REMOVE_MOMENT (state, id) {
      state.list = state.list.filter(m => m.id !== id)
    }
  },
  actions: {
    createMoment ({ commit }, form) {
      const id = genId()
      const now = new Date().toISOString()
      commit('ADD_MOMENT', {
        id,
        tripId: form.tripId,
        creatorId: form.creatorId,
        kind: form.kind || 'normal',
        text: form.text || '',
        media: form.media || [],
        mood: form.mood || null,
        pointId: form.pointId || null,
        location: form.location || null,
        capturedAt: form.capturedAt || now,
        timePrecision: form.timePrecision || 'exact',
        createdAt: now,
        visibility: form.visibility || 'trip',
        tags: form.tags || [],
        physicalSubtype: form.physicalSubtype || null
      })
      return id
    },
    updateMoment ({ commit }, payload) {
      commit('UPDATE_MOMENT', payload)
    },
    removeMoment ({ commit }, id) {
      commit('REMOVE_MOMENT', id)
    }
  }
}
